import request from "@/api/request";
import { SignupResponse } from "@/interfaces/Freearea/SignupResponse.ts";
import { TwoFactorPendingResponse } from "@/interfaces/Freearea/TwoFactorPendingResponse.ts";

// todo: check signatures, maybe move to params? as use signupparams eg for google.
class AuthService {
  static async login(username: string, password: string): Promise<string | TwoFactorPendingResponse> {
    return await request.post("/auth/login", { username, password });
  }

  static async verify2fa(pending_token: string, code: string): Promise<string> {
    return await request.post("/auth/2fa/verify", { pending_token, code });
  }

  static async forgot_password(email: string, username: string | null): Promise<void> {
    return await request.post("/auth/forgot_password", { username, email });
  }

  static async google(
    token: string,
    language: string,
    landing_id: number | null = null,
  ): Promise<SignupResponse | string | TwoFactorPendingResponse> {
    return await request.post("/auth/google", { token, language, landing_id });
  }

  static async reset_password(password: string, reset_key: string): Promise<void> {
    return await request.post("/auth/reset_password", { password, reset_key });
  }

  static async login_by_hash(hash: string): Promise<string> {
    return await request.post("/auth/login_by_hash", { hash });
  }
}

export default AuthService;
